<div class="subBlockContainer">
    <div class="subBlockContent">
      <loading-screen *ngIf="!loadContent" [isScrolled]="true" [showBlurTable]="false"></loading-screen>
      <div class="inner-subBlock-wrapper">
        <div class="page-title-wrapper">
          <div class="page-title-position">
              <label class="page-title-lable">Add New Item</label>
              <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
            </div>
  
          <div class="row filter-wrapper filter-wrapper-margin">
            <div class="col-md-4">
              <div class="searchInputGroup">
                <div class="searchIcon">
                  <img src="../../images/new_ui/filter.png">
                </div>
                <input class="searchInput" type="text" placeholder="Filter" [(ngModel)]="searchOrder">
              </div>
            </div>
          </div>
          <div class="top-divider"></div>
          <div class="shared-outer-wrapper">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" style="width:60%">DESCRIPTION</th>
                  <th scope="col" class="align-center" style="width:15%">PRICE</th>
                  <th scope="col" class="align-center" style="width:15%">QTY</th>
                  <th scope="col" class="align-center" style="width:10%"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of newItemsList | TableFilterMultiple: ['description', 'stockCode'] : searchOrder">
                  <td style="position:relative" class="description-td" style="width:60%">
                    <span class="description-popup">{{item?.description}}</span>
                    <div class="result-info">
                      <div class="produc-secondary-title-wrapper">
                        <span class="light-text">STOCK CODE:&nbsp;</span>
                        <span>{{item?.stockCode}}</span>
                      </div>
                    </div>
                  </td>
                  <td class="align-center" style="width:15%">{{item?.itemPrice}}/mth</td>
                  <td class="align-center" style="width:15%"><input integerOnly type="text" class="input-box-small" value="1"
                      #orderquantity /></td>
                  <td class="align-center" style="width:10%">
                    <button class="button button-red button-small"
                      (click)="addAnnuityItem(item, orderquantity.value);">Add</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>